/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LinkPropertyOrganizationRequest
 */
export interface LinkPropertyOrganizationRequest {
    /**
     * 
     * @type {number}
     * @memberof LinkPropertyOrganizationRequest
     */
    organizationId: number;
    /**
     * 
     * @type {string}
     * @memberof LinkPropertyOrganizationRequest
     */
    role?: string | null;
}

/**
 * Check if a given object implements the LinkPropertyOrganizationRequest interface.
 */
export function instanceOfLinkPropertyOrganizationRequest(value: object): value is LinkPropertyOrganizationRequest {
    if (!('organizationId' in value) || value['organizationId'] === undefined) return false;
    return true;
}

export function LinkPropertyOrganizationRequestFromJSON(json: any): LinkPropertyOrganizationRequest {
    return LinkPropertyOrganizationRequestFromJSONTyped(json, false);
}

export function LinkPropertyOrganizationRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): LinkPropertyOrganizationRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'organizationId': json['organizationId'],
        'role': json['role'] == null ? undefined : json['role'],
    };
}

export function LinkPropertyOrganizationRequestToJSON(json: any): LinkPropertyOrganizationRequest {
    return LinkPropertyOrganizationRequestToJSONTyped(json, false);
}

export function LinkPropertyOrganizationRequestToJSONTyped(value?: LinkPropertyOrganizationRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'organizationId': value['organizationId'],
        'role': value['role'],
    };
}

